import { render } from "./TemplateTextView.vue?vue&type=template&id=63c9e5ba&scoped=true"
import script from "./TemplateTextView.vue?vue&type=script&lang=js"
export * from "./TemplateTextView.vue?vue&type=script&lang=js"

import "./TemplateTextView.vue?vue&type=style&index=0&id=63c9e5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c9e5ba"]])

export default __exports__